<p-chip class="m-badge" [label]="label()"></p-chip>
